<template>
  <div
    id="dropzone"
    ref="dropzone"
    :class="['dropzone', dragging && 'dropzone--over']"
    @drop.prevent="fileDrop"
    @dragover.prevent="dragging = true"
    @dragleave.prevent="dragging = false"
  >
    <div
      v-if="!file"
      class="dropzone__content"
    >
      <h2 class="dropzone__title">
        Drag and drop file to upload <br> or
      </h2>
      <v-button
        class="dropzone__cta"
        size="lg"
        @click="chooseFiles"
      >
        Choose file
      </v-button>
      <div>{{ additionalMsg }}</div>
      <input
        id="upload-button"
        type="file"
        class="d-none"
        @change="fileAdded"
      >
    </div>
  </div>
</template>

<script>
  import Button from '@/atoms/Button/index'
  import Validator from '@/common/customvalidator'

  export default {
    components: {
      'v-button': Button,
    },
    props: {
      additionalMsg: {
        type: String,
        default: null
      },
    },
    data() {
      return {
        file: null,
        dragging: false
      }
    },
    methods: {
      fileDrop(e) {
        this.file = e.dataTransfer.files[0];
        this.emitFile();
      },
      fileAdded(e) {
        let file = this.$el.querySelector('#upload-button').files[0];
        let errors = Validator.validate('file', file);
        if(errors.length < 1) {
          this.file = file;
          this.emitFile();
        } else {
          this.emitErrors(errors);
        }
      },
      emitFile() {
        this.$emit('file-added', this.file);
      },
      emitErrors(errors) {
        this.$emit('file-error', errors);
      },
      chooseFiles(e) {
        this.$el.querySelector('#upload-button').click();
      }
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";

  .dropzone {
    background-color: $athens;
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 5px;
    text-align: center;
    background-image: linear-gradient(to right, $pigeon 50%, transparent 50%), linear-gradient(to right, $pigeon 50%, transparent 50%), linear-gradient(to bottom, $pigeon 50%, transparent 50%), linear-gradient(to bottom, $pigeon 50%, transparent 50%);
    background-position: left top, left bottom, left top, right top;
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    background-size: 20px 1px, 20px 1px, 1px 20px, 1px 20px;
    @include transitionOut();
    &__content {
      padding-top: 1.5rem;
      padding-bottom: 1.5rem;
    }
    &--over {
      background-color: $mercury;
      background-size: 10px 1px, 10px 1px, 1px 10px, 1px 10px;
      @include transitionIn();
    }
  }
</style>
